import { WorkOrderDocument } from '../../domain/types/work-order';
import { WorkOrderFormDocument, WorkOrderUnsavedDocument } from './types';

export const isDocumentUnsaved = <W extends WorkOrderDocument>(
  document: WorkOrderFormDocument<W>
): document is WorkOrderUnsavedDocument<W> => {
  return (document as WorkOrderUnsavedDocument<W>)._file !== undefined;
};
